export default {"src":"/_next/static/media/YGGJ1.9360d0b7.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};